// extracted by mini-css-extract-plugin
export default {"wrap":"HAy4eLV2","section":"rqMNHPHw","sectionTitle":"UMhHeieu","empty":"AUo2ApH7"};